import { useState } from 'react';
import { Alert } from '@mui/material';
import { AssessmentButtons, AssessmentCard } from '../shared';
import { useAppDispatch } from '../../../pages/assessment';
import { updateMeta } from '../../../redux/meta';
import { WhatWeTreatList } from '../icon-lists';
import WhatWeCantTreatDialog from '../what-we-cant-treat-dialog';

const IntroScreenThree = () => {
  const dispatch = useAppDispatch();
  const [isContinuing, setIsContinuing] = useState(false);
  const onClick = () => {
    setIsContinuing(true);
    dispatch(updateMeta());
  };

  return (
    <>
      <AssessmentCard>
        <WhatWeTreatList />
        <WhatWeCantTreatDialog />
      </AssessmentCard>
      <Alert severity="info" sx={{ mt: 3 }}>
        Our psychiatrists provide medication management and supportive therapy
        together, so they're unable to treat patients looking for traditional
        talk therapy only.
      </Alert>
      <AssessmentButtons
        primary={{
          children: 'Continue',
          fullWidth: true,
          disabled: isContinuing,
          loading: isContinuing,
          onClick,
        }}
      />
    </>
  );
};

export default IntroScreenThree;
